import React from "react";
import { CSSProperties } from "styled-components";

import DialogStyles from "../styles/components/DialogStyles";

const { StyledModal, StyledModalHeader, StyledModalBody } = DialogStyles;

interface DialogProps {
    openModal: boolean;
    className?: string;
    children?: React.ReactNode;
    actions?: React.ReactNode;
    modalIcon?: React.ReactNode;
    closeModal?: boolean;
    onHide?: () => void;
    size?: string;
    style?: CSSProperties;
    dialogClassName?: string;
}

function Dialog({
    className,
    openModal,
    onHide,
    children,
    actions,
    size = "sm",
    style,
    modalIcon,
    closeModal = true,
    dialogClassName,
}: DialogProps) {
    return (
        <StyledModal
            show={openModal}
            className={className}
            size={size}
            onHide={onHide}
            style={style}
            centered
            keyboard={false}
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName={dialogClassName}
        >
            {closeModal && <StyledModalHeader closeButton />}
            {modalIcon && <div>{modalIcon}</div>}
            <StyledModalBody>{children}</StyledModalBody>
            {actions}
        </StyledModal>
    );
}

export default Dialog;
